import React from "react";
import { useRecordContext, Labeled } from "react-admin";
import { bwColours } from "../theme";

const STEP_CIRCLE_SIZE = 20;
const STEP_DIAMOND_SIZE = 10;
const LINE_THICKNESS = 2;

const FermentAutomationStepsMiniField = ({
  label = "Phases",
}): React.ReactElement => {
  const record = useRecordContext();

  const steps = record?.automation?.steps;
  if (!Array.isArray(steps) || steps.length === 0) {
    return (
      <Labeled label={label}>
        <span style={{ color: "#999" }}>None</span>
      </Labeled>
    );
  }

  const logs = record?.automation?.log;

  return (
    <Labeled label={label}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          paddingTop: 5,
          marginLeft: -6,
        }}
      >
        <div
          style={{
            position: "relative",
            display: "flex",
            alignItems: "center",
          }}
        >
          {/* Light horizontal line */}
          <div
            style={{
              position: "absolute",
              left: STEP_CIRCLE_SIZE,
              right: STEP_CIRCLE_SIZE,
              top: (STEP_CIRCLE_SIZE - LINE_THICKNESS) / 2,
              height: LINE_THICKNESS,
              backgroundColor: bwColours.primary.beige,
              zIndex: 0,
            }}
          />

          {steps.map((step: any, index: number) => {
            const hasCheckpoint =
              step.checkpoint?.enabled === true && step.checkpoint?.description;
            const isCompleted = logs && !!logs[index]?.executedAt;
            const checkpointCompleted =
              hasCheckpoint &&
              isCompleted &&
              !!logs[index]?.checkpointClearedAt;

            return (
              <div
                key={index}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  position: "relative",
                  zIndex: 1,
                  marginLeft: 6,
                  marginRight: 6,
                }}
              >
                <div
                  style={{
                    width: STEP_CIRCLE_SIZE,
                    height: STEP_CIRCLE_SIZE,
                    borderRadius: "50%",
                    backgroundColor: isCompleted
                      ? bwColours.primary.beige
                      : bwColours.primary.offwhite,
                    borderColor: bwColours.primary.beige,
                    borderWidth: 1,
                    borderStyle: "solid",
                  }}
                />

                {hasCheckpoint ? (
                  /* Diamond shape for steps with checkpoints */
                  <div
                    style={{
                      marginLeft: 2,
                      marginTop: 1,
                      width: STEP_DIAMOND_SIZE,
                      height: STEP_DIAMOND_SIZE,
                      transform: "rotate(45deg)",
                      backgroundColor: checkpointCompleted
                        ? bwColours.primary.beige
                        : bwColours.primary.offwhite,
                      borderColor: checkpointCompleted
                        ? bwColours.primary.beige
                        : isCompleted
                          ? bwColours.primary.red
                          : bwColours.primary.beige,
                      borderWidth: 1,
                      borderStyle: "solid",
                    }}
                  />
                ) : null}

                {/* Step label
                <span
                  style={{
                    marginTop: 8,
                    fontSize: 11,
                    color: isCompleted ? "#4caf50" : "#757575",
                    fontWeight: isCompleted ? 600 : 400,
                    whiteSpace: "nowrap",
                  }}
                >
                  {step.checkpoint?.description || `Phase ${index + 1}`}
                  </span>*/}
              </div>
            );
          })}
        </div>
      </div>
    </Labeled>
  );
};

export { FermentAutomationStepsMiniField };
